module.exports = __webpack_public_path__ + "static/img/document.a5bd190.png";